import { render, staticRenderFns } from "./ProfileBadge.vue?vue&type=template&id=36b2d8a3&scoped=true&"
import script from "./ProfileBadge.vue?vue&type=script&lang=js&"
export * from "./ProfileBadge.vue?vue&type=script&lang=js&"
import style0 from "./ProfileBadge.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ProfileBadge.vue?vue&type=style&index=1&id=36b2d8a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b2d8a3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
